// this is to help in moving feedback button up on the client when there's a footer
import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

// Safe default so consumers rendered outside the provider read
// isBottomBarVisible = false — i.e. no fixed bottom bar — instead of crashing.
export const BottomBarContext = createContext({
  isBottomBarVisible: false,
  setIsBottomBarVisible: () => {},
});

export const BottomBarProvider = ({ children }) => {
  const [isBottomBarVisible, setIsBottomBarVisible] = useState(false);

  const value = useMemo(
    () => ({ isBottomBarVisible, setIsBottomBarVisible }),
    [isBottomBarVisible, setIsBottomBarVisible],
  );

  return (
    <BottomBarContext.Provider value={value}>
      {children}
    </BottomBarContext.Provider>
  );
};

BottomBarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
